import React from 'react';
import type { FieldValidation } from '@rjsf/utils';
import FormControl from '@material-ui/core/FormControl';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import { Box, Typography } from '@mui/material';
import Markdown from 'markdown-to-jsx';
import { DisclaimerTextComponentProps } from './schema';

export { DisclaimerTextSchema } from './schema';

export const DisclaimerText = (props: DisclaimerTextComponentProps) => {

  const { uiSchema, formData, onChange, required, rawErrors } = props;

  const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange(event.target.checked ? true : false);
  };
  const { title, message, label } = uiSchema?.['ui:options'] || {};

  return (
    <>
      <Box
        p={2}
        mb={2}
        sx={{ backgroundColor: '#f9f9f9', borderLeft: '5px solid #b0b0b0', borderRadius: '4px' }}
      >
        <Typography variant="h6" component="div" gutterBottom>
          { title as string || 'Disclaimer' }
        </Typography>
        <Typography variant="body2" component="div">
          <Markdown>
            {message as string || 'By clicking the checkbox below, you agree that you understand the implications of the operation you are about to perform, and that you are aware that it will modify the environment.'}
          </Markdown>
        </Typography>
      </Box>
      <FormControl
        margin="normal"
        required={required}
        error={rawErrors?.length > 0 && !formData}
      >
        <FormControlLabel
          control={
            <Checkbox
              id="validateCheckbox"
              checked={formData as boolean}
              onChange={handleCheckboxChange}
              disabled={formData}
            />
          }
          label={label || 'I agree to the above statement'}
        />
      </FormControl>
    </>
  );
};

export const DisclaimerTextValidation = (
  value: boolean,
  validation: FieldValidation,
) => {
  if (!value) {
    validation.addError('You must agree to proceed.');
  }
};
